var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sidesheet",
    {
      staticClass: "positions",
      attrs: { active: _vm.active, title: _vm.title },
      on: { close: _vm.onClose },
    },
    [
      _vm.loading
        ? _c("loader", {
            staticClass: "loader mt-3",
            attrs: { active: _vm.loading, height: "400" },
          })
        : _c("div", [
            _c("div", { staticClass: "d-none d-md-block" }, [
              _c("table", { staticClass: "intervals-table" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Интервал")]),
                    _c("th", [_vm._v("Сотрудники")]),
                    _c("th", [_vm._v("Заказов обработано")]),
                    _c("th", [_vm._v("Нагрузка, ฿")]),
                    _c("th", [_vm._v("Норматив выработки, ฿")]),
                    _c("th", [_vm._v("Сумма штрафов/премий")]),
                  ]),
                ]),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.intervals, function (interval) {
                      return [
                        _c(
                          "tr",
                          {
                            key: interval.id + "-total",
                            staticClass: "interval-header",
                          },
                          [
                            _c("td", { staticClass: "text-nowrap" }, [
                              _vm._v(" " + _vm._s(interval.interval) + " "),
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(interval.employees.length)),
                            ]),
                            _c("td", { attrs: { align: "right" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getNumber(interval.total.ordersCount)
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("td", { attrs: { align: "right" } }, [
                              _vm._v(
                                _vm._s(_vm.getNumber(interval.total.load))
                              ),
                            ]),
                            _c("td", { attrs: { align: "right" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getNumber(
                                      interval.total.revenueStandart
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("td", { attrs: { align: "right" } }, [
                              _c(
                                "span",
                                {
                                  class: {
                                    "positive-number":
                                      interval.total.finesAndBonuses > 0,
                                    "negative-number":
                                      interval.total.finesAndBonuses < 0,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getNumber(
                                          interval.total.finesAndBonuses
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._l(interval.employees, function (employee) {
                          return _c(
                            "tr",
                            { key: interval.id + "-" + employee.id },
                            [
                              _c("td"),
                              _c("td", [_vm._v(_vm._s(employee.name))]),
                              _c("td", { attrs: { align: "right" } }, [
                                _vm._v(
                                  _vm._s(_vm.getNumber(employee.ordersCount))
                                ),
                              ]),
                              _c("td", { attrs: { align: "right" } }, [
                                _vm._v(_vm._s(_vm.getNumber(employee.load))),
                              ]),
                              _c("td", { attrs: { align: "right" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getNumber(employee.revenueStandart)
                                  )
                                ),
                              ]),
                              _c("td", { attrs: { align: "right" } }, [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "positive-number":
                                        employee.finesAndBonuses > 0,
                                      "negative-number":
                                        employee.finesAndBonuses < 0,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getNumber(
                                            employee.finesAndBonuses
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }),
                      ]
                    }),
                  ],
                  2
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "d-md-none table-container" },
              [
                _c("htable", [
                  _c("table", [
                    _c(
                      "tr",
                      [
                        _c("th", [_vm._v("Интервал")]),
                        _vm._l(_vm.intervals, function (interval) {
                          return _c(
                            "td",
                            {
                              key: interval.id,
                              staticClass: "interval-header",
                              attrs: { colspan: interval.employees.length + 1 },
                            },
                            [_vm._v(" " + _vm._s(interval.interval) + " ")]
                          )
                        }),
                      ],
                      2
                    ),
                    _c(
                      "tr",
                      [
                        _c("th", [_vm._v("Сотрудники")]),
                        _vm._l(_vm.intervals, function (interval) {
                          return [
                            _c(
                              "td",
                              {
                                key: interval.id + "-employees",
                                staticClass: "interval-header",
                                attrs: { align: "right" },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(interval.employees.length) + " "
                                ),
                              ]
                            ),
                            _vm._l(interval.employees, function (employee) {
                              return _c(
                                "td",
                                {
                                  key:
                                    interval.id + "-employees-" + employee.id,
                                  attrs: { align: "right" },
                                },
                                [_vm._v(" " + _vm._s(employee.name) + " ")]
                              )
                            }),
                          ]
                        }),
                      ],
                      2
                    ),
                    _c(
                      "tr",
                      [
                        _c("th", [
                          _vm._v("Заказов"),
                          _c("br"),
                          _vm._v("обработано"),
                        ]),
                        _vm._l(_vm.intervals, function (interval) {
                          return [
                            _c(
                              "td",
                              {
                                key: interval.id + "-orders",
                                staticClass: "interval-header",
                                attrs: { align: "right" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getNumber(interval.total.ordersCount)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm._l(interval.employees, function (employee) {
                              return _c(
                                "td",
                                {
                                  key: interval.id + "-orders-" + employee.id,
                                  attrs: { align: "right" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getNumber(employee.ordersCount)
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            }),
                          ]
                        }),
                      ],
                      2
                    ),
                    _c(
                      "tr",
                      [
                        _c("th", [_vm._v("Нагрузка, ฿")]),
                        _vm._l(_vm.intervals, function (interval) {
                          return [
                            _c(
                              "td",
                              {
                                key: interval.id + "-load",
                                staticClass: "interval-header",
                                attrs: { align: "right" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.getNumber(interval.total.load)) +
                                    " "
                                ),
                              ]
                            ),
                            _vm._l(interval.employees, function (employee) {
                              return _c(
                                "td",
                                {
                                  key: interval.id + "-load-" + employee.id,
                                  attrs: { align: "right" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.getNumber(employee.load)) +
                                      " "
                                  ),
                                ]
                              )
                            }),
                          ]
                        }),
                      ],
                      2
                    ),
                    _c(
                      "tr",
                      [
                        _c("th", [
                          _vm._v("Норматив"),
                          _c("br"),
                          _vm._v("выр-ки, ฿"),
                        ]),
                        _vm._l(_vm.intervals, function (interval) {
                          return [
                            _c(
                              "td",
                              {
                                key: interval.id + "-revenueStandart",
                                staticClass: "interval-header",
                                attrs: { align: "right" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getNumber(
                                        interval.total.revenueStandart
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm._l(interval.employees, function (employee) {
                              return _c(
                                "td",
                                {
                                  key:
                                    interval.id +
                                    "-revenueStandart-" +
                                    employee.id,
                                  attrs: { align: "right" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getNumber(employee.revenueStandart)
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            }),
                          ]
                        }),
                      ],
                      2
                    ),
                    _c(
                      "tr",
                      [
                        _c("th", [
                          _vm._v("Сумма"),
                          _c("br"),
                          _vm._v("штрафов/"),
                          _c("br"),
                          _vm._v("премий"),
                        ]),
                        _vm._l(_vm.intervals, function (interval) {
                          return [
                            _c(
                              "td",
                              {
                                key: interval.id + "-finesAndBonuses",
                                staticClass: "interval-header",
                                attrs: { align: "right" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "negative-number":
                                        interval.total.finesAndBonuses < 0,
                                      "positive-number":
                                        interval.total.finesAndBonuses > 0,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getNumber(
                                            interval.total.finesAndBonuses
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._l(interval.employees, function (employee) {
                              return _c(
                                "td",
                                {
                                  key:
                                    interval.id +
                                    "-finesAndBonuses-" +
                                    employee.id,
                                  attrs: { align: "right" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        "negative-number":
                                          employee.finesAndBonuses < 0,
                                        "positive-number":
                                          employee.finesAndBonuses > 0,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getNumber(
                                              employee.finesAndBonuses
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }